import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {black500, blueColor, green500, orange500, red500} from "../../assets/jss/main";
import {Box, DialogContent, Grid} from "@mui/material";
import {ReactComponent as CloseIcon} from "../../assets/img/wms/close.svg";
import {ReactComponent as ValidatedIcon} from "assets/img/validated.svg";
import {ReactComponent as ErrorIcon} from "assets/img/error.svg"
import {ReactComponent as WarningIcon} from "assets/img/warning.svg"
import {ReactComponent as InfoIcon} from "assets/img/info-circle.svg"
import {ReactComponent as EllipseIcon} from "assets/img/ellipse.svg"
import Dialog from "@mui/material/Dialog";

ColoredToast.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    label: PropTypes.element.isRequired,
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'neutral']),
    isDesktop: PropTypes.bool,
    customTimeout: PropTypes.number,
    iconFill: PropTypes.string,
    iconStroke: PropTypes.string,
};

const margin = 16;

const palette = {
    neutral: { main: black500, light: '#FFFFFF', icon: EllipseIcon, iconFill: '#FFFFFF', iconStroke: black500},
    success: { main: green500, light: '#FFFFFF', icon: ValidatedIcon, iconFill: '#FFFFFF',  iconStroke: green500},
    error:   { main: red500,   light: '#FFFFFF', icon: ErrorIcon, iconFill: '#FFFFFF',  iconStroke: red500},
    warning: { main: orange500, light: '#FFFFFF', icon: WarningIcon, iconFill: '#FFFFFF',  iconStroke: orange500},
    info:    { main: blueColor, light: '#FFFFFF', icon: InfoIcon, iconFill: '#FFFFFF', iconStroke: blueColor},
};

const basePaperRoot = {
    width: '100%',
    borderRadius: '100px',
    margin: '0',
    padding: '12px',
    boxShadow: '0px 4px 32px 0px rgba(34, 34, 34, 0.12), 0px 4px 32px 0px rgba(34, 34, 34, 0.12)',
};

const toastStyle = {
    width: 'fit-content',
    marginX: 'auto',
    '& .MuiDialog-container': {
        alignItems: 'flex-end',
        justifyContent: 'center',
        paddingBottom: '24px',
    },
};

function ColoredToast({
    open,
    handleClose,
    disablePortal,
    label,
    type = 'neutral',
    isDesktop = false,
    customTimeout = null,
    iconFill = null,
    iconStroke = null,
}) {

    useEffect(() => {
        if (true === open) {
            setTimeout(() => {
                handleClose()
            }, customTimeout)
        }
    }, [open]);

    const typeStyle = palette[type];
    const IconComponent = typeStyle.icon;
    const resolvedIconFill = iconFill ?? typeStyle.iconFill;
    const resolvedIconStroke = iconStroke ?? typeStyle.iconStroke;

    const paperRoot = {
        ...basePaperRoot,
        backgroundColor: typeStyle.main,
        color: typeStyle.light,
    };

    const finalToastStyle = {
        ...toastStyle,
        '& .MuiPaper-root ': paperRoot,
        ...(isDesktop && {'& .MuiDialog-container ': {justifyContent: 'end'}, '& .MuiPaper-root ': {...paperRoot, width: '25%'}}),
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disablePortal={disablePortal}
            disableScrollLock
            disableAutoFocus
            disableEnforceFocus
            hideBackdrop
            sx={finalToastStyle}
        >
            <DialogContent sx={{padding: 0}}>
                <Grid
                    container
                    alignItems={'center'}
                    alignContent={'center'}
                    justifyContent={'space-between'}
                >
                    <Grid
                        container
                        alignItems={'center'}
                        width={'fit-content'}
                        flexWrap={"nowrap"}
                        item
                    >
                        <Grid container sx={{
                            width: 'fit-content',
                            marginRight: '8px'
                        }}>
                            {IconComponent && (
                                <Box
                                    component="span"
                                    sx={{
                                        display: 'inline-flex',
                                        '& svg *': {
                                            fill: resolvedIconFill,
                                            stroke: resolvedIconStroke,
                                        }
                                    }}
                                >
                                    <IconComponent />
                                </Box>
                            )}
                        </Grid>

                        <Grid
                            container
                            direction={'column'}
                            sx={{width: 'fit-content'}}
                        >
                            <span
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 600
                                }}
                            >
                                {label}
                            </span>
                        </Grid>
                    </Grid>

                    <Grid container sx={{width: 'fit-content', marginLeft: '8px'}}>
                        <Box
                            onClick={handleClose}
                            component="span"
                            sx={{
                                display: 'inline-flex',
                                '& svg *': {
                                    fill: 'white',
                                    stroke: 'white',
                                }
                            }}
                        >
                            <CloseIcon/>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default ColoredToast;